import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { setFundChartLineAnnotations } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/line-annotations/line-annotations.actions';
import { getLineAnnotationModalStateForSeries, getSeriesLineAnnotations, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/line-annotations/line-annotations.selectors';
import { FUND_CHART_LINE_WEIGHT_MEDIUM, FUND_CHART_LINE_WEIGHT_THICK, FUND_CHART_LINE_WEIGHT_THIN, LINE_ANNOTATION_AREA_CHART, LINE_ANNOTATION_AVG, LINE_ANNOTATION_BOOL_KEYS, LINE_ANNOTATION_DIVIDENDS, LINE_ANNOTATION_EARNINGS_RESULTS, LINE_ANNOTATION_FORCE_ORIGINAL, LINE_ANNOTATION_FORCE_ORIGINAL_HELP_MODAL_NAME, LINE_ANNOTATION_FORCE_SINGLE_PANEL, LINE_ANNOTATION_FORCE_SINGLE_PANEL_MODAL_NAME, LINE_ANNOTATION_LINE_COLOR, LINE_ANNOTATION_LINE_WEIGHT, LINE_ANNOTATION_MAX, LINE_ANNOTATION_MIN, LINE_ANNOTATION_SPINOFFS, LINE_ANNOTATION_SPLITS, LINE_ANNOTATIONS_SECURITY_TYPE_ENABLED_EVENTS_MAP, LINE_WEIGHT_LABEL_MAP, } from '../fund-chart-correlations/fund-chart-correlations.constants';
import { CorrelationType } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { FundChartOptionValue, } from 'ChartApp/ts/interfaces/fund-chart.interface';
import { ColorPickerComponent } from 'Angular/features/components/inputs/color-picker/color-picker.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/color-picker/color-picker.component";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
const _c0 = ["colorPickerComponent"];
const _c1 = a0 => ({ show: a0 });
const _c2 = a0 => ({ backgroundColor: a0 });
const _c3 = a0 => ({ "custom-control-indicator": a0 });
const _c4 = a0 => ({ disabled: a0 });
function LineAnnotationsModalComponent_label_36_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 36)(1, "input", 37);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_label_36_Template_input_click_1_listener() { const option_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setWeight(option_r3.weight)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span");
    i0.ɵɵelementStart(3, "span", 38);
    i0.ɵɵelement(4, "div");
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", option_r3.weight === ctx_r3.seriesState.line_weight);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(7, _c3, option_r3.weight === ctx_r3.seriesState.line_weight));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("thickness ", option_r3.cssClass));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r3.label);
} }
function LineAnnotationsModalComponent_div_51_label_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 40)(1, "input", 41);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_div_51_label_4_Template_input_click_1_listener() { const option_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.setOption(option_r6)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 42);
    i0.ɵɵelementStart(3, "span", 43);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(5, _c4, ctx_r3.eventOptionDisabled(option_r6)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r3.seriesState[option_r6.value])("disabled", ctx_r3.eventOptionDisabled(option_r6));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r6.label);
} }
function LineAnnotationsModalComponent_div_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31)(1, "label", 19);
    i0.ɵɵtext(2, "View Events");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 32);
    i0.ɵɵtemplate(4, LineAnnotationsModalComponent_div_51_label_4_Template, 5, 7, "label", 39);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r3.ANNOTATIONS_EVENTS_OPTIONS);
} }
function LineAnnotationsModalComponent_label_56_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 40)(1, "input", 44);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_label_56_Template_input_click_1_listener() { const option_r8 = i0.ɵɵrestoreView(_r7).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setOption(option_r8)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 42);
    i0.ɵɵelementStart(3, "span", 43);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r8 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r3.seriesState[option_r8.value]);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r8.label);
} }
function LineAnnotationsModalComponent_div_61_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_div_61_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r11); const lineCustomization_r10 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); const helpModal_r12 = i0.ɵɵreference(63); return i0.ɵɵresetView(helpModal_r12.openModal(ctx_r3.LINE_ANNOTATION_MODAL_NAMES[lineCustomization_r10.value])); });
    i0.ɵɵtext(1, "(?)");
    i0.ɵɵelementEnd();
} }
function LineAnnotationsModalComponent_div_61_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 40)(2, "input", 44);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_div_61_Template_input_click_2_listener() { const lineCustomization_r10 = i0.ɵɵrestoreView(_r9).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setOption(lineCustomization_r10)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 42);
    i0.ɵɵelementStart(4, "span", 43);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(6, "\u00A0 ");
    i0.ɵɵtemplate(7, LineAnnotationsModalComponent_div_61_span_7_Template, 2, 0, "span", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const lineCustomization_r10 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r3.seriesState[lineCustomization_r10.value]);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", lineCustomization_r10.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.LINE_ANNOTATION_MODAL_NAMES[lineCustomization_r10.value]);
} }
export class LineAnnotationsModalComponent {
    constructor(store) {
        this.store = store;
        this.objectValues = Object.values;
        this.isOpen = false;
        this.showWeightDropDown = false;
        this.currentLineWeightClass = '';
        this.currentLineWeightLabel = '';
        this.enabledEvents = [];
        this.LINE_ANNOTATION_MODAL_NAMES = {
            [LINE_ANNOTATION_FORCE_ORIGINAL]: LINE_ANNOTATION_FORCE_ORIGINAL_HELP_MODAL_NAME,
            [LINE_ANNOTATION_FORCE_SINGLE_PANEL]: LINE_ANNOTATION_FORCE_SINGLE_PANEL_MODAL_NAME,
        };
        this.ANNOTATIONS_EVENTS_OPTIONS = [
            {
                label: 'Earnings Results (E)',
                value: LINE_ANNOTATION_EARNINGS_RESULTS,
            },
            {
                label: 'Dividends (D)',
                value: LINE_ANNOTATION_DIVIDENDS,
            },
            {
                label: 'Splits (S)',
                value: LINE_ANNOTATION_SPLITS,
            },
            {
                label: 'Spinoffs (S)',
                value: LINE_ANNOTATION_SPINOFFS,
            },
        ];
        this.ANNOTATIONS_LINES_OPTIONS = [
            {
                label: 'Min. Line',
                value: LINE_ANNOTATION_MIN,
            },
            {
                label: 'Max. Line',
                value: LINE_ANNOTATION_MAX,
            },
            {
                label: 'Average Line',
                value: LINE_ANNOTATION_AVG,
            },
        ];
        this.ANNOTATIONS_LINES_CUSTOMIZATIONS = [
            {
                label: 'Force Original Data',
                value: LINE_ANNOTATION_FORCE_ORIGINAL,
            },
            {
                label: 'Force on Single Panel',
                value: LINE_ANNOTATION_FORCE_SINGLE_PANEL,
            },
            {
                label: 'Area Chart',
                value: LINE_ANNOTATION_AREA_CHART,
            },
        ];
        this.LINE_WEIGHT_OPTIONS_MAP = {
            thin: {
                cssClass: 'thickness-thin',
                label: LINE_WEIGHT_LABEL_MAP[FUND_CHART_LINE_WEIGHT_THIN],
                weight: FUND_CHART_LINE_WEIGHT_THIN,
            },
            medium: {
                cssClass: 'thickness-medium',
                label: LINE_WEIGHT_LABEL_MAP[FUND_CHART_LINE_WEIGHT_MEDIUM],
                weight: FUND_CHART_LINE_WEIGHT_MEDIUM,
            },
            thick: {
                cssClass: 'thickness-thick',
                label: LINE_WEIGHT_LABEL_MAP[FUND_CHART_LINE_WEIGHT_THICK],
                weight: FUND_CHART_LINE_WEIGHT_THICK,
            },
        };
        this.useCustomColors = false;
        this.seriesIndex = 0;
        this.seriesLength = 0;
        this.modalState = [];
        this.seriesState = {};
        this.isAlive = true;
        this.mapStateToComponent = (state) => {
            this.rootState = state;
            this.seriesLineAnnotations = getSeriesLineAnnotations(state);
        };
    }
    ngOnInit() {
        this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    eventOptionDisabled(option) {
        return !this.enabledEvents?.includes(option.value);
    }
    openModal(seriesIndex) {
        this.modalState = getLineAnnotationModalStateForSeries(this.seriesLineAnnotations)(this.rootState);
        this.initializeModal(seriesIndex);
        this.isOpen = true;
    }
    updateSeriesIndex(seriesIndex) {
        this.seriesIndex = seriesIndex;
        this.initializeModal(this.seriesIndex);
    }
    initializeModal(seriesIndex) {
        this.seriesIndex = seriesIndex;
        this.seriesState = this.modalState[seriesIndex];
        this.enabledEvents = LINE_ANNOTATIONS_SECURITY_TYPE_ENABLED_EVENTS_MAP[this.seriesState.securityType];
        this.useCustomColors = this.rootState.fundChart[FundChartOptionValue.SHOW_CUSTOM_COLORS];
        this.seriesLength = this.seriesLineAnnotations.length;
        // If we have colors explicitly set in the `lineAnnotations`, we need to set our
        // UI elements appropriately.
        const { line_color, line_weight } = this.seriesState;
        this.setColor(line_color);
        this.setWeight(line_weight);
        this.showWeightDropDown = false;
    }
    closeModal() {
        this.isOpen = false;
    }
    resetModal() {
        for (let i = 0; i < this.modalState.length; i += 1) {
            LINE_ANNOTATION_BOOL_KEYS.forEach((key) => {
                this.modalState[i][key] = false;
            });
            if (this.modalState[i].calcId === CorrelationType.CORRELATION) {
                // For Correlation items, the following line annotation options default to true
                this.modalState[i][LINE_ANNOTATION_FORCE_ORIGINAL] = true;
                this.modalState[i][LINE_ANNOTATION_FORCE_SINGLE_PANEL] = true;
            }
            const color = this.colorPickerComponent.getDefaultColorForIndex(i);
            this.modalState[i].line_color = color;
            this.modalState[i].line_weight = '';
        }
        const color = this.colorPickerComponent.getDefaultColorForIndex(this.seriesIndex);
        this.setColor(color);
        this.setWeight('');
    }
    setOption(option) {
        this.seriesState[option.value] = !this.seriesState[option.value];
    }
    submitModal() {
        const cleanedState = {};
        this.modalState.forEach((lineAnnotation) => {
            const lineAnnotationOptions = {};
            LINE_ANNOTATION_BOOL_KEYS.forEach((key) => {
                lineAnnotationOptions[key] = lineAnnotation[key];
            });
            // Only set the line format-related items if a user has actually set them.
            if (lineAnnotation.line_color) {
                lineAnnotationOptions[LINE_ANNOTATION_LINE_COLOR] = lineAnnotation.line_color;
            }
            if (lineAnnotation.line_weight) {
                lineAnnotationOptions[LINE_ANNOTATION_LINE_WEIGHT] = lineAnnotation.line_weight;
            }
            const securityKey = lineAnnotation.securitylistName
                ? lineAnnotation.securitylistName
                : lineAnnotation.securityId;
            if (!cleanedState[securityKey]) {
                cleanedState[securityKey] = {};
            }
            cleanedState[securityKey][lineAnnotation.calcId] = lineAnnotationOptions;
        });
        this.store.dispatch(setFundChartLineAnnotations({ lineAnnotations: cleanedState }));
        this.closeModal();
    }
    setWeight(lineWeight) {
        this.seriesState.line_weight = lineWeight;
        let option;
        // If there is no currently-selected weight, we show a "default" value as the
        // pseudo-selected value in the closed dropdown.
        if (lineWeight) {
            option = this.LINE_WEIGHT_OPTIONS_MAP[lineWeight];
        }
        else {
            option = {
                cssClass: 'thickness-unselected',
                label: 'Default',
                weight: FUND_CHART_LINE_WEIGHT_MEDIUM,
            };
        }
        this.currentLineWeightClass = option.cssClass;
        this.currentLineWeightLabel = option.label;
        this.showWeightDropDown = false;
    }
    setColor(color) {
        this.colorPickerComponent.setColor(color, this.seriesIndex);
        this.seriesState.line_color = color;
    }
    currentColorHandler(color) {
        this.seriesState.line_color = color;
    }
}
LineAnnotationsModalComponent.ɵfac = function LineAnnotationsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LineAnnotationsModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
LineAnnotationsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LineAnnotationsModalComponent, selectors: [["ycn-line-annotations-modal"]], viewQuery: function LineAnnotationsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.colorPickerComponent = _t.first);
    } }, standalone: false, decls: 66, vars: 31, consts: [["colorPickerComponent", ""], ["helpModal", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "mb-2"], [1, "bg-panel"], [1, "panel-header"], [1, "panel-title", 3, "textContent"], [1, "panel-actions"], [1, "panel-action"], [1, "form-label", "form-label-thin", "mr-1", "text-nowrap"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], ["ycnIcon", "", 1, "ml-1", 3, "name"], [1, "divider-horizontal"], [1, "modal-section"], [1, "form-inline", "pt-3", "pb-3"], [1, "form-label", "form-label-large"], [1, "form-label", "form-label-thin"], [1, "dropdown"], [1, "btn", "btn-block", "btn-secondary", "dropdown-toggle", 3, "click"], [1, "text-default"], [1, "dropdown-menu"], ["class", "dropdown-item custom-control custom-checkbox custom-checkbox-style1", 4, "ngFor", "ngForOf"], [3, "setColorHandler", "useCustomColors"], [1, "thickness-wrap"], [1, "modal-section", "pt-2", "pb-2"], [1, "form-label", "form-label-large", "mb-20"], [1, "row"], ["class", "col-4", 4, "ngIf"], [1, "col-4"], [1, "custom-controls-stacked", "mt-2"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "submitButtonText"], [1, "dropdown-item", "custom-control", "custom-checkbox", "custom-checkbox-style1"], [1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-description", "thickness-wrap"], ["class", "custom-control custom-checkbox", 3, "class", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked", "disabled"], [1, "custom-control-indicator"], [1, "custom-control-description"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], ["class", "help-toggler", 3, "click", 4, "ngIf"], [1, "help-toggler", 3, "click"]], template: function LineAnnotationsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function LineAnnotationsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function LineAnnotationsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "p");
        i0.ɵɵtext(5, "Use the navigation controls to move between securities and their annotation preferences individually.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
        i0.ɵɵelement(8, "div", 8);
        i0.ɵɵelementStart(9, "div", 9)(10, "div", 10)(11, "div", 11);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 10)(14, "button", 12);
        i0.ɵɵlistener("click", function LineAnnotationsModalComponent_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateSeriesIndex(ctx.seriesIndex - 1)); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(15, "svg", 13);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(16, "span");
        i0.ɵɵtext(17, "Previous");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(18, "div", 10)(19, "button", 12);
        i0.ɵɵlistener("click", function LineAnnotationsModalComponent_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateSeriesIndex(ctx.seriesIndex + 1)); });
        i0.ɵɵelementStart(20, "span");
        i0.ɵɵtext(21, "Next");
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(22, "svg", 14);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(23, "div", 15);
        i0.ɵɵelementStart(24, "div", 16)(25, "div", 17)(26, "div", 18);
        i0.ɵɵtext(27, "Line Style");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 19);
        i0.ɵɵtext(29, "Weight");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 20)(31, "a", 21);
        i0.ɵɵlistener("click", function LineAnnotationsModalComponent_Template_a_click_31_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.showWeightDropDown = !ctx.showWeightDropDown); });
        i0.ɵɵelement(32, "span");
        i0.ɵɵelementStart(33, "span", 22);
        i0.ɵɵtext(34);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(35, "span", 23);
        i0.ɵɵtemplate(36, LineAnnotationsModalComponent_label_36_Template, 7, 9, "label", 24);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(37, "div", 19);
        i0.ɵɵtext(38, "Color");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 20)(40, "ycn-color-picker", 25, 0);
        i0.ɵɵlistener("setColorHandler", function LineAnnotationsModalComponent_Template_ycn_color_picker_setColorHandler_40_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.currentColorHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(42, "div", 19);
        i0.ɵɵtext(43, "Example");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 26);
        i0.ɵɵelement(45, "div");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(46, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "div", 27)(48, "div", 28);
        i0.ɵɵtext(49, "Settings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 29);
        i0.ɵɵtemplate(51, LineAnnotationsModalComponent_div_51_Template, 5, 1, "div", 30);
        i0.ɵɵelementStart(52, "div", 31)(53, "label", 19);
        i0.ɵɵtext(54, "View Min / Max / Avg");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "div", 32);
        i0.ɵɵtemplate(56, LineAnnotationsModalComponent_label_56_Template, 5, 2, "label", 33);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(57, "div", 31)(58, "label", 19);
        i0.ɵɵtext(59, "Line Customizations");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(60, "div", 32);
        i0.ɵɵtemplate(61, LineAnnotationsModalComponent_div_61_Template, 8, 3, "div", 34);
        i0.ɵɵelement(62, "ycn-help-modal", null, 1);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(64, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(65, "ycn-simple-modal-footer", 35);
        i0.ɵɵlistener("cancelHandler", function LineAnnotationsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_65_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.resetModal()); })("submitHandler", function LineAnnotationsModalComponent_Template_ycn_simple_modal_footer_submitHandler_65_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submitModal()); });
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Security Annotations");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("textContent", ctx.seriesState.label);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate2("", ctx.seriesIndex + 1, " of ", ctx.seriesLength);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.seriesIndex === 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-back");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", ctx.seriesIndex + 1 === ctx.seriesLength);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-collapse");
        i0.ɵɵadvance(10);
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("thickness ", ctx.currentLineWeightClass, " "));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.currentLineWeightLabel);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(27, _c1, ctx.showWeightDropDown));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.objectValues(ctx.LINE_WEIGHT_OPTIONS_MAP));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("useCustomColors", ctx.useCustomColors);
        i0.ɵɵadvance(5);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(29, _c2, ctx.seriesState.line_color));
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("thickness ", ctx.currentLineWeightClass));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.seriesState.securityType !== "correlation");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.ANNOTATIONS_LINES_OPTIONS);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.ANNOTATIONS_LINES_CUSTOMIZATIONS);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("cancelButtonText", "Reset")("submitButtonText", "Apply");
    } }, dependencies: [i2.ColorPickerComponent, i3.NgForOf, i3.NgIf, i4.DisabledDirective, i5.HelpModalComponent, i6.IconDirective, i7.ModalBaseComponent, i8.SimpleModalFooterComponent, i9.SimpleModalHeaderComponent], encapsulation: 2 });
